import { Injectable } from '@angular/core';
// import { Http, Response, Headers, RequestOptions, ResponseContentType } from import { HttpClient } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';
import { CONFIGURATION } from '../app.constants';
import { IReport, IReportViewer, IValidValue, ISubScribeReport } from '../models/index';

@Injectable({ providedIn: 'root' })
export class ReportService {
    private baseUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/GetReports?gtid=';
    private immdiateParentUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/GetParentName?dealerId=';
    private ReportUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/GetPerameters?';
    private ReportParamsUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/Getparams';
    private ExportReportUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/ExportReport?Timeout=3000';
    private SharingReportUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/Sharingreport';
    private ReportMatchDataUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/BuilReportMatchData';
    private SubscibereportUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/Subscibereport';
    private EditSubscibereportUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/UpdateSubscibereport';
    private SubscibereportListUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/GetSubscriptionList?';
    private subscriptionDeleteUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/DeleteSubscription?';
    private SubscirptionDataUrl = CONFIGURATION.baseUrls.ReportBaseURL + 'ReportViewer/GetSubscriptionDetails?sid=';
    private AdmtServiceUrl = CONFIGURATION.baseUrls.ADMTServiceURL;
    constructor(
        private http: HttpClient) {
        this.InitializeReportViewer();
        this.InitializeValidValues();
        this.InitializeReport();
    }

    public GetReportParams(reportPath: string, chid: string): Observable<any> {
        let url = `${this.ReportUrl + 'chid=' + chid + '&ReportPath='}${reportPath}`;
        return this.http.get(url);          
    }

    public GetParams(reportParams: IReportViewer[]): Observable<IReportViewer[]> {
        let httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options ={ headers: httpHeaders };
        return this.http.post<IReportViewer[]>(this.ReportParamsUrl, (JSON.stringify(reportParams)), options);          
    }

    // public ExportReport(reportParams: IReportViewer[]): Observable<IReportViewer[]> {
    //     return new Observable<IReportViewer[]();
    //     // let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //     // let options = { responseType: 'blob', headers: headers };
    //     // return this.http.post<IReportViewer[]>(this.ExportReportUrl, (JSON.stringify(reportParams)), options);         
    // }

    public BuilReportMatchData(reportParams: ISubScribeReport): Observable<ISubScribeReport> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options ={ headers: headers };
        return this.http.post<ISubScribeReport>(this.ReportMatchDataUrl, (JSON.stringify(reportParams)), options);
    }

    public SubscibeReport(reportParams: IReportViewer[]): Observable<IReportViewer[]> {

        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
        return this.http.post<IReportViewer[]>(this.SubscibereportUrl, (JSON.stringify(reportParams)), options)
         
    }

    public SaveEditSubscription(reportParams: IReportViewer): Observable<IReportViewer> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
        return this.http.post<IReportViewer>(this.EditSubscibereportUrl, (JSON.stringify(reportParams)), options);        

    }

    public SharingReport(reportParams: IReportViewer[]): Observable<IReportViewer[]> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
        return this.http.post<IReportViewer[]>(this.SharingReportUrl, (JSON.stringify(reportParams)), options);
    }

    public GetSubscriptions(sid: string): Observable<IReportViewer[]> {
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
        return this.http.post<IReportViewer[]>(this.SharingReportUrl, sid, options);
    }

    getClientFilesPostageTrackingReportList(client:string):Observable<any>{
        const url = this.AdmtServiceUrl + 'report/GetClientFilesPostageTrackingReport?client_name='+ client;
        return this.http.get(url);
        
    }

    GetSubscriptionList = (uid, hid) => {
        return this.http.get(this.SubscibereportListUrl + "hid=" + hid + "&uid=" + uid);
    }
   
   

    GetSubscription(sid: any): Observable<IReportViewer> {
        return this.http.get<IReportViewer>(this.SubscirptionDataUrl + sid);
    }

    getReports(geoTypeId: number): Observable<IReport[]> {
        return this.http.get<IReport[]>(this.baseUrl + geoTypeId);
         
    }

    getImmediateParent(dealerId: number): Observable<any> {
        return this.http.get(this.immdiateParentUrl + dealerId);
    }
    DeleteSubscriptionById(sid) {
        return this.http.get(this.subscriptionDeleteUrl + "sid=" + sid);
    }
    
    getDataGapsReport(oem):Observable<any>{
        const url = this.AdmtServiceUrl + 'report/getDataGapsReport?oem='+oem;
        return this.http.get(url);
        
    }
    getDataGapsRecords(oem):Observable<any>{
        const url = this.AdmtServiceUrl + 'report/getDataGapRecords?oem='+oem;
        return this.http.get(url);
        
    }
    getDataGapsList(oem):Observable<any>{
        const url = this.AdmtServiceUrl + 'report/getDataGapsReportList?oem='+oem;
        return this.http.get(url);
        
    }
    
    private extractData(response: Response) {
        let body = response.json();
        return body;
    }

    private handleError(error: Response | any): Observable<any> {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            errMsg = `${error.status} - ${error.statusText || ''}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    InitializeReport(): IReport {
        return {
            TypeGroupCode: null,
            Name: null,
            Description: null,
            PathUrl: null,
            LstReport: null
        };
    }

    InitializeReportViewer(): IReportViewer {
        return {
            Name: null,
            ParameterTypeName: null,
            Nullable: null,
            NullableSpecified: null,
            AllowBlank: null,
            AllowBlankSpecified: null,
            MultiValue: null,
            MultiValueSpecified: null,
            QueryParameter: null,
            QueryParameterSpecified: null,
            Prompt: null,
            PromptUser: null,
            PromptUserSpecified: null,
            Dependencies: null,
            ValidValuesQueryBased: null,
            ValidValuesQueryBasedSpecified: null,
            ValidValues: [{ Label: null, Value: null }],
            DefaultValuesQueryBased: null,
            DefaultValuesQueryBasedSpecified: null,
            DefaultValues: null,
            ParameterStateName: null,
            ErrorMessage: null,
            ReportPath: null,
            ReportName: null,
            EmailDesc: null,
            EmailSubject: null,
            EmailTO: null,
            EmailCC: null,
            EmailBCC: null,
            EmailComment: null,
            EmailExportType: null,
            EmailEventType: null,
            ScheduleList: null,
            ScheduleType: null,
            Interval: null,
            Parameters: null,
            MatchData: null,
            SId: null,
            UserId: null,
            DealerHierarchyId: null,
            SchDefinition: null
        };
    }

    InitializeValidValues(): IValidValue {
        return {
            Label: null,
            Value: null
        };
    }
}

